import React, { useImperativeHandle, useRef, useState } from "react";
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import SignaturePanel, { SignaturePanelHandle } from "../signaturePanel/SignaturePanel";

type Props = {
  onSubmitBlob?: (blob: Blob) => void
}

export type SignaturePanelPopupHandle = {
  show: () => void,
  hide: () => void
}

type State = {
  visible: boolean
}

const PopupSignaturePanel: React.ForwardRefRenderFunction<SignaturePanelPopupHandle, Props> = (props, ref) => {
  const [pdfBlob, setPdfBlob] = useState<Blob>();
  const [state, setState] = useState<State>({visible: false});
  const [loading, setLoading] = useState(false);
  const signatureRef = useRef<SignaturePanelHandle>(null);

  useImperativeHandle(ref, () => ({
    show() {
      signatureRef.current?.clear();
      setState({visible:true});
    },
    hide() {
      setState({visible:false});
    },
  }));

  return (
    <React.Fragment>
      <Popup
        visible={state.visible}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        fullScreen={false}
        onHidden={()=> setState({visible:false})}
        title="Firma"
        container=".dx-viewport"
        height={380}
        width={550}
      >
        <Position
          at="center"
          my="center"
          of=""
          collision="fit"
        />
 
        <SignaturePanel ref={signatureRef} onSubmitBlob={props.onSubmitBlob} />

      </Popup>
      
    </React.Fragment>
  );
}

export default React.forwardRef(PopupSignaturePanel);

